import { PAYMENT_METHODS } from '@/modules/perseo-billing/constants/src/providers/payment-methods';
import type { IAvailablePaymentMethodsResponse } from '@/modules/perseo-billing/interfaces';
import { isWeddingFlow } from '@/modules/shared/utils/isWeddingFlow';

import { PaymentMethod } from './components/payment-method';
import PaymentMethodTitle from './components/title/payment-method-title';

type OtherPaymentsProps = {
  paymentMethods: IAvailablePaymentMethodsResponse['wallets'];
  isForeignDocument?: boolean;
};

export const OtherPaymentMethods = ({
  paymentMethods,
  isForeignDocument = false
}: OtherPaymentsProps) => {
  const isWedding = isWeddingFlow();

  let filteredMethods = paymentMethods;

  // Wedding flow filtering
  if (isWedding) {
    filteredMethods = filteredMethods?.filter(
      (paymentMethod) => paymentMethod.methodId !== PAYMENT_METHODS.GIFT_CARD
    );
  }

  if (isForeignDocument) {
    filteredMethods = filteredMethods?.filter(
      (paymentMethod) => paymentMethod.methodId === PAYMENT_METHODS.WEBPAY
    );
  }

  return (
    <div className="co-flex co-flex-col co-gap-24px">
      {!isForeignDocument && (
        <PaymentMethodTitle title={'Otros medios de pago'} />
      )}
      {filteredMethods?.map((paymentMethod, index) => {
        return (
          <PaymentMethod
            paymentMethod={paymentMethod}
            accordionIndex={2}
            index={index}
            key={index}
            defaultExpanded={
              isForeignDocument &&
              paymentMethod.methodId === PAYMENT_METHODS.WEBPAY
            }
            alwaysExpanded={
              isForeignDocument &&
              paymentMethod.methodId === PAYMENT_METHODS.WEBPAY
            }
          />
        );
      })}
    </div>
  );
};
